import { Observable, catchError, map, of } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { ComponentDataSourceService } from '../../component-data-source.service';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { environment } from '../../../../environment/environment';
import { GroupCalendarStatsResponse } from '../../../../components/duna/duna-events-group-calendar/group-calendar-settings.interface';
import { parseJsonInput } from '../../../../components/duna/duna-events-group-calendar/group-calendar-settings.utils';

export function group_calendar_stats(service: ComponentDataSourceService) {
  return {
    name: 'Group Calendar Stats',
    description: 'Aggregated template counts per station for group calendar',
    execute: (params?: LoadDataParams): Observable<GroupCalendarStatsResponse> => {
      const year = Number(params?.queryParams?.['year'] ?? new Date().getFullYear());
      const month = Number(params?.queryParams?.['month'] ?? new Date().getMonth());
      const locationGuids = parseJsonInput<string[]>(
        params?.queryParams?.['calendarLocationGuids'],
        []
      );

      return service.http
        .get<GroupCalendarStatsResponse>(`${environment.apiUrl}/events/group-calendar/stats`, {
          params: {
            year: String(year),
            month: String(month),
            location_guids: JSON.stringify(locationGuids),
            _nocache: String(Date.now())
          }
        })
        .pipe(
          map((result) => ({
            year: result?.year ?? year,
            month: result?.month ?? month,
            items: Array.isArray(result?.items) ? result.items : []
          })),
          catchError((error: unknown) => {
            if (!(error instanceof HttpErrorResponse) || error.status !== 404) {
              console.warn('[group_calendar_stats] Failed to load stats:', error);
            }
            return of({ year, month, items: [] });
          })
        );
    }
  };
}
